import React from "react";

/**
 * Real Mabuhay Capital Lending logo (gold "M" in gold circle on navy).
 * Uses the official artwork stored in /public/brand/.
 *
 *  logo.png         — full logo (M in circle + MABUHAY CAPITAL LENDING + tagline)
 *  logo-mark.png    — just the "M in circle" square, cropped from the full logo
 *  logo-wordmark.png — just the "MABUHAY CAPITAL LENDING" wordmark strip
 */

// Small square mark: use in tight spaces (headers, avatars, splash icon)
export function BrandMark({ size = 40, className = "", rounded = true }) {
  return (
    <img
      src="/brand/logo-mark.png"
      alt="Mabuhay Capital Lending"
      width={size}
      height={size}
      className={`${rounded ? "rounded-lg" : ""} ${className}`}
      style={{ display: "inline-block", objectFit: "contain" }}
    />
  );
}

// Full logo image (mark + wordmark + tagline). Use in prominent placements.
export function BrandLogoImage({ className = "", size = 160 }) {
  return (
    <img
      src="/brand/logo.png"
      alt="Mabuhay Capital Lending — Trusted. Reliable. Discreet."
      width={size}
      height={size}
      className={className}
      style={{ display: "inline-block", objectFit: "contain" }}
    />
  );
}

// Wordmark-only strip (MABUHAY / CAPITAL LENDING)
export function BrandWordmark({ height = 44, className = "" }) {
  return (
    <img
      src="/brand/logo-wordmark.png"
      alt="Mabuhay Capital Lending"
      height={height}
      className={className}
      style={{ display: "inline-block", height, width: "auto", objectFit: "contain" }}
    />
  );
}

/**
 * BrandLockup — mark + wordmark, ideal for app headers.
 *  variant="dark"  → shown on light backgrounds
 *  variant="light" → shown on dark/navy backgrounds
 * The mark itself already contains navy background, so both variants look correct.
 */
export function BrandLockup({ variant = "dark", markSize = 44, className = "" }) {
  const wordColor = variant === "light" ? "text-white" : "text-slate-900";
  const subColor = variant === "light" ? "text-amber-300" : "text-amber-700";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <BrandMark size={markSize} />
      <div className="leading-tight">
        <div
          className={`font-bold tracking-tight text-lg sm:text-xl ${wordColor}`}
          style={{ fontFamily: "Outfit", letterSpacing: "0.03em" }}
        >
          MABUHAY
        </div>
        <div
          className={`text-[10px] sm:text-[11px] font-semibold tracking-[0.24em] uppercase ${subColor}`}
          style={{ fontFamily: "Outfit" }}
        >
          Capital Lending
        </div>
      </div>
    </div>
  );
}

export default BrandLockup;
